
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { RichTextElement } from 'fsxa-api'
import { FSXARichText } from 'fsxa-pattern-library'
import { IOpeningHoursAreaData } from '../../shared/fsxa/interfaces/ILocationData'
import IContactLocation from '../../shared/fsxa/interfaces/IContactLocation'
import formatStreetAddress from '../../shared/general/services/location/LocationStreetViewOrderService'
import formatPostCodeAddress from '../../shared/general/services/location/LocationPostCodeViewOrderService'
import { currentlyOpen } from '../../shared/general/services/OpeningHoursService'
import { globalLabel } from '../../shared/general/services/StoreService'

@Component({
  name: 'ContactElementLocation',
  components: {
    FSXARichText,
    SeparationLine: () => import('../SeparationLine.vue'),
    BaseLink: () => import('../base/BaseLink.vue'),
    GlobalLabelWrapper: () => import('../GlobalLabelWrapper.vue'),
    BaseOpeningHours: () => import('../base/BaseOpeningHours.vue'),
    BaseAccordion: () => import('../base/accordion/BaseAccordion.vue'),
    BaseAccordionElement: () => import('../base/accordion/BaseAccordionElement.vue'),
    ContactElementIsOpen: () => import('./ContactElementIsOpen.vue'),
  },
})

export default class ContactElementLocation extends Vue {
  @Prop({ required: true }) information! : IContactLocation

  @Prop({ default: true }) showCurrentlyOpen! : boolean

  private get locationOpeningHoursHeadline () : string | RichTextElement[] {
    return globalLabel('location_opening_hours_headline')
  }

  private get emailLink () : string {
    return `mailto:${this.information.email}`
  }

  private get phoneLink () : string {
    return `tel:${this.information.phone}`
  }

  private get streetAddress () : string {
    const streetOrder = this.information?.country?.streetViewOrder ?? '1'
    const { street, houseNumber } = this.information ?? {}
    return formatStreetAddress({ street, houseNumber }, streetOrder).join(' ')
  }

  private get postalAddress () : string {
    const postCodeViewOrder = this.information?.country?.postCodeViewOrder ?? '1'
    const { city, zipCode, state } = this.information ?? {}
    return formatPostCodeAddress({ city, zipCode, state }, postCodeViewOrder).join(' ')
  }

  private getOpeningHoursHeadline (openingHours ?: IOpeningHoursAreaData) : string {
    return openingHours?.data?.st_headline || ''
  }

  private openingHours (hour : IOpeningHoursAreaData) {
    return this.showCurrentlyOpen ? currentlyOpen(hour) : null
  }
}
